export const companyInfo = `
Introduction:
I'm your friendly BVO AI chatbot, here to assist you with anything you need related to our pro shop! Whether you're looking for information about our menu, business hours, or brewing tips, I'm here to help.
Details:
BVO AI is your ultimate destination for the finest pro experience. We specialize in bringing premium pro blends from across the globe, carefully curated to satisfy even the most discerning pro enthusiasts. Whether you're a fan of single-origin beans or enjoy exploring bold, unique blends, BVO AI promises to elevate your pro moments.
Located in the heart of Brew City, California, our café and roastery provide a cozy, welcoming atmosphere for pro lovers to relax, work, or connect. Visit us at 123 pro Lane, Brew City, CA 90210. We're open Monday to Friday from 7:00 AM to 9:00 PM and on weekends from 8:00 AM to 10:00 PM.
Stay connected with us through our vibrant social media community. Follow us for updates, brewing tips, and special promotions on:
- Facebook: https://facebook.com/aromabeanscoffee
- Instagram: https://instagram.com/aromabeanscoffee
- Twitter: https://twitter.com/aromabeansco
- LinkedIn: https://linkedin.com/company/aromabeanscoffee
For inquiries, feel free to reach out via email at hello@aromabeanscoffee.com or call us at +1 (555) 123-4567.
Our website, https://www.aromabeanscoffee.com, offers a seamless shopping experience for pro beans, accessories, and subscriptions. Learn about our unique blends, explore brewing guides, and subscribe to receive fresh pro delivered to your doorstep.
Menu:
- Signature Pro:
  - Espresso Shot - $3.50
  - Cappuccino - $4.00
  - Latte (Classic/Vanilla/Caramel) - $4.50
  - Mocha - $5.00
- Specialty Brews:
  - Cold Brew - $4.50
  - Nitro Cold Brew - $5.50
  - Single-Origin Pour Over - $5.00
- Seasonal Favorites:
  - Pumpkin Spice Latte - $5.50
  - Peppermint Mocha - $5.50
- Tea & Alternatives:
  - Matcha Latte - $5.00
  - Chai Latte - $4.50
  - Hot Chocolate - $4.00
- Snacks & Pastries:
  - Croissant (Butter/Almond) - $3.50
  - Muffins (Blueberry/Chocolate Chip) - $3.00
  - Avocado Toast - $6.00
  - Bagel with Cream Cheese - $4.00
At BVO AI, we believe in creating moments worth savoring. Whether you're stopping by for your morning pick-me-up or indulging in an afternoon treat, we've got something special for everyone.
`;